
    export default 
    {
    "publicDocument": {
        "warn": "Nuestro sistema ha detectado que la contraseña es demasiado fácil de descifrar. Por favor, dirígete a Ajustes-Cuenta para restablecer la contraseña después de iniciar sesión.",
        "newPass": "Por favor, ingresa una nueva contraseña.",
        "safety": "La contraseña no es segura.",
        "scope": ""
    }
}